import axios from 'axios';

export const uploadAgreementFirmedFile = async ({
  data,
  newToken,
  agreementId,
}) => {
  try {
    const response = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_API_URL}/agreements/sign-request/${agreementId}`,
      data,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const createSigningRequest = async ({
  data,
  agreement,
  token,
  agreementId,
}) => {
  try {
    const { profile: admin, supplier } = agreement;

    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests`,
      data: {
        name: `Signing Request for Agreement ${agreementId}`,
        delivery_mode: 'email',
      },
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    const signingRequestResponse = response.data;

    const adminName = admin.name?.split(' ')[0] || '';
    const adminSurname = admin.name?.split(' ')[1] || '';
    const responseNotify = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestResponse.id}/signers`,
      data: {
        info: {
          locale: 'en',
          first_name: adminName,
          last_name: adminSurname,
          email: admin.emailBilling ? admin.emailBilling : admin.emailReference,
          // phone_number: '3792576409',
        },
        signature_level: 'electronic_signature',
        signature_authentication_mode: 'otp_email',
      },
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (responseNotify instanceof Error) {
      return { error: responseNotify };
    }

    const supplierName = supplier.name?.split(' ')[0] || '';
    const supplierSurname = supplier.name?.split(' ')[1] || '';
    const responseNotify2 = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestResponse.id}/signers`,
      data: {
        info: {
          locale: 'en',
          first_name: supplierName,
          last_name: supplierSurname,
          email: supplier.emailBilling
            ? supplier.emailBilling
            : supplier.emailReference,
          // phone_number: '3792576409',
        },
        signature_level: 'electronic_signature',
        signature_authentication_mode: 'otp_email',
      },
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (responseNotify2 instanceof Error) {
      return { error: responseNotify2 };
    }

    const form = new FormData();
    form.append('nature', 'signable_document');
    form.append('parse_anchors', 'true');
    form.append('file', data.get('file'));

    const responseDocument = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestResponse.id}/documents`,
      data: form,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (responseDocument instanceof Error) {
      return { error: responseDocument };
    }

    const responseActivate = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestResponse.id}/activate`,
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (responseActivate instanceof Error) {
      return { error: responseActivate };
    }

    const responseGet = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_DIGITAL_SIGNATURE_API}/signature_requests/${signingRequestResponse.id}`,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_YOUSIGNE_API_KEY}`,
      },
    });

    if (responseGet instanceof Error) {
      return { error: responseGet };
    }

    return {
      data: {
        signingRequestId: signingRequestResponse.id,
        documentId: responseDocument.data.id,
      },
    };
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const uploadSuppCondoAgreement = async ({ data, newToken }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/agreements`,
      data,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const uploadSuppAdminAgreement = async ({ data, newToken }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/agreements`,
      data,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteSuppCondoAgreement = async ({
  agreementId,
  key,
  newToken,
}) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/agreements/${agreementId}`,
      data: { key },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export const deleteSuppAdminAgreement = async ({
  agreementId,
  key,
  newToken,
}) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/agreements/${agreementId}`,
      data: { key },
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    // Sentry TODO
    return { error };
  }
};
